import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useCountDown } from 'src/hooks/utils';
import { secondsToMinutes } from 'src/utils/format/time';

const JobFormCountDown = ({ title, inProgressTitle, time, onClick, className }) => {
  const [timer, inProgress, restart] = useCountDown(time);
  const text = (inProgress && inProgressTitle) || title;

  useEffect(() => {
    const finished = !inProgress;
    if (finished) {
      onClick(true);
      restart(); 
    }
  }, [inProgress]);

  const handleClick = useCallback(() => {
    if (inProgress) {
      onClick(false);
      restart(); 
    }
  }, [inProgress]);

  const formatted = secondsToMinutes(timer);
  return (
    <div className={className} onClick={handleClick}>
      {text}
      {inProgress && ` ${formatted}`}
    </div>
  );
};

JobFormCountDown.propTypes = {
  title: PropTypes.string,
  inProgressTitle: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  time: PropTypes.number.isRequired,
};

JobFormCountDown.defaultProps = {
  title: 'Resend',
  inProgressTitle: 'Resend in',
  className: null,
};

export default React.memo(JobFormCountDown);
